<template>
  <v-dialog
          v-model="dialog"
          max-width="610"
  >
    <v-card v-if="userAddress.id">
      <v-card-title class="headline">
        Адрес № {{ userAddress.id }}
      </v-card-title>
      <v-card-text class="userAddress-modal">
        <v-form ref="tabForm" v-model="valid">
        <v-text-field
                v-model="userAddress.name"
                label="Название"
                :rules="[rules.required]"
                required
                outlined
        ></v-text-field>

        <v-row>
          <v-col sm="8">
            <v-autocomplete
                    v-model="userAddress.combinedAddress"
                    :items="streets"
                    :item-text="item => item.name"
                    :item-value="item => item.id"
                    outlined
                    label="Улица"
                    return-object

            ></v-autocomplete>
          </v-col>
          <v-col sm="4">
            <v-text-field
                    v-model="userAddress.home"
                    label="Дом"
                    :rules="[rules.required]"
                    required
                    outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-radio-group v-model="userAddress.type" row>
          <v-radio label="Квартира" value="apartment"></v-radio>
          <v-radio label="Дом" value="house"></v-radio>
        </v-radio-group>
        <v-row>
          <v-col>
            <v-text-field
                    v-model="userAddress.apartment"
                    label="Квартира"
                    required
                    outlined
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
                    v-model="userAddress.entrance_number"
                    label="Парадная"
                    required
                    outlined
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
                    v-model="userAddress.code"
                    label="Код"
                    required
                    outlined
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
                    v-model="userAddress.floor"
                    label="Этаж"
                    required
                    outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-textarea
                class="mt-5"
                v-model="userAddress.comment"
                label="Примечание"
                required
                outlined
        ></v-textarea>
        <v-checkbox label="Основной адрес" v-model="userAddress.is_main">Основной адрес</v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
                outlined
                @click="dialog = false; userAddress = {}"
        >
          Закрыть
        </v-btn>
        <v-btn
                @click="save"
                :loading="loading"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
    import UserService from './../api/UserService'
    import StreetService from "../api/StreetService";
    import AreaService from "../api/AreaService";

    export default {
        name: 'AddressModal',
        props: {
            value: Object,
        },
        components: {},
        data() {
            return {
                rules: {
                    required: value => !!value || 'Нужно заполнить',
                    requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
                },
                dialog: false,
                valid: false,
                loading: false,
                userAddress: this.value,
                streets: []
            };
        },
        methods: {
          save(){
              this.$refs.tabForm.validate()
              if(!this.valid){
                  return false;
              }
              this.loading = true
              this.userAddress.street = this.userAddress.combinedAddress.id
              UserService.updateAddress(this.userAddress.id, this.userAddress).then(response => {

              }).catch(error => {
                  let message = 'Ошибка при сохранении адреса'
                  if (error.response && error.response.data && error.response.data.message) {
                      message = error.response.data.message
                  }
                  alert(message)
              }).finally(() => {
                  this.dialog = false;
                  this.loading = false
                  this.userAddress = {};
              });


          }
        },
    mounted() {
      AreaService.combinedList().then(response => {
          this.streets = response.data
      })
    },
    watch: {
      userAddress(val) {
        if(val.id){
          this.dialog = true
        } else {
          this.dialog = false
        }

        this.$emit('input', val);
      },
      value(val){
        if(val.id){
          this.dialog = true
        } else {
          this.dialog = false
        }

        this.userAddress = val;
      },
      dialog(val){
        if(!val){
          this.userAddress = {}
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .client-info{
    margin-bottom: 44px;
  }
  .check-in-iiko{
    position: absolute;
    right: 32px;
    top: 32px;
    color: green;
  }
  .userAddress-modal{
    ::v-deep{
      .v-radio .v-label{
        transform: none!important;
      }
    }
    .summary{
      text-align: right;
      font-size: 16px;
      color: #212529;
      buserAddress-top: 1px solid #EAF0F6;
      padding: 44px 0;
      buserAddress-bottom: 1px solid #EAF0F6;
      line-height: 26px;
      .total{
        margin-top: 16px;
        font-size: 22px;
      }
    }
    .userAddress-item{
      padding: 16px 0;
      buserAddress-top: 1px solid #EAF0F6;
    }
    .main{
      display: grid;
      grid-template-columns: 1fr 110px;
      margin-bottom: 4px;
      font-size: 16px;
      line-height: 22px;
      font-weight: bold;
      .name{
      }
      .price{
        text-align: right;
      }
    }
    ul{
      li{
        display: grid;
        grid-template-columns: 1fr 110px;
        font-weight: normal;
        color: #8C959D;
        margin-bottom: 4px;
        .name{
          line-height: 22px;
          font-weight: normal;
          color: #8C959D;
          padding-left: 0;
        }
        .price{
          text-align: right;
        }
      }
    }
  }
</style>
